var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"song-audio"},[_c('audio',{ref:"player",attrs:{"src":_vm.url,"controls":"controls","preload":"true"},on:{"canplay":_vm.startPlay,"ended":_vm.ended,"timeupdate":_vm.timeupdate}})])}
var staticRenderFns = []

export { render, staticRenderFns }